export { default as ic_clock } from "./ic_clock.svg?react";
export { default as ic_empty_avatar } from "./ic_empty_avatar.svg?react";
export { default as ic_empty_list } from "./ic_empty_list.svg?react";
